import { createContext, type Context } from 'react';

export const detectionBoundary: Context<boolean> = createContext(true);
